'use client';

import Image from 'next/image';
import Link from 'next/link';

const EventsSection = () => {
  const upcomingEvents = [
    {
      src: '/images/vc-start up-singapore-2029.webp',
      alt: 'vc-start up-singapore-2029',
      link: "https://luma.com/ls6zfnmw",
    },
    {
      src: '/images/ai-capital-connect-abu-dhabi-2026.webp',
      alt: 'ai-capital-connect-abu-dhabi-2026',
      link: "https://luma.com/AICapitalConnect?k=c",
    },
  ];

  const pastEvents = [
    {
      src: '/images/aicc-abu-dhabi-luma-event.webp',
      alt: 'aicapitalconnect-abu-dhabi-luma-event',
      link: "https://lu.ma/aicapconnectabudhabi",
    },
    {
      src: "/images/aicapitalconnect-singapor-luma-event.webp",
      alt: "aicapitalconnect-singapor-luma-event",
      link: "https://luma.com/p9905tv6",
    },
    {
      src: "/images/ai-capital-connect-past-event.webp",
      alt: "ai-capital-connect-past-event",
      link: "https://luma.com/tk2pa1hh",
    },
    {
      src: "/images/vc-community-demo-day.webp",
      alt: "vc-community-demo-day",
      link: "https://luma.com/5vst7s6m",
    },
  ];

  return (
    <section data-component-id="src/app/EventsSection.tsx:44:4" data-component-path="src/app/EventsSection.tsx" data-component-line="44" data-component-file="EventsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22events%22%2C%22className%22%3A%22relative%20max-w-%5B1252px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%20py-12%20sm%3Apy-16%20rounded-lg%20pb-5%20bg-black%20border%20border-%5B%232a3ef0%5D%20shadow-%5B0px_0px_40px_%232d3e5026%5D%20rounded-%5B14px%5D%20-mt-%5B120px%5D%20mb-%5B20px%5D%22%7D" id="events" className="relative max-w-[1252px] mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 rounded-lg pb-5 bg-black border border-[#2a3ef0] shadow-[0px_0px_40px_#2d3e5026] rounded-[14px] -mt-[120px] mb-[20px]"
    //       style={{
    //     borderImage: 'linear-gradient(180deg, #20293200 0%, #2a3ef0 100%) 1',
    //     borderImageSlice: 1,
    //   }}
      >

      {/* 🔹 Gradient Top Background (like screenshot) */}
      

      <div data-component-id="src/app/EventsSection.tsx:54:6" data-component-path="src/app/EventsSection.tsx" data-component-line="54" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20z-10%20max-w-%5B1200px%5D%20mx-auto%20px-4%22%7D" className="relative z-10 max-w-[1200px] mx-auto px-4">

        {/* 🔹 Heading */}
       <h2 data-component-id="src/app/EventsSection.tsx:57:7" data-component-path="src/app/EventsSection.tsx" data-component-line="57" data-component-file="EventsSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-white%20text-3xl%20sm%3Atext-5xl%20font-semibold%20mb-1%20text-center%22%2C%22textContent%22%3A%22Events%20%26%20Initiatives%22%7D" className="text-white text-3xl sm:text-5xl font-semibold mb-1 text-center">
          Events & Initiatives
        </h2>

        {/* 🔹 Main Card */}
        {/* <div className="bg-black rounded-2xl border border-[#1f2a44] shadow-[0px_0px_40px_#00000040] p-6 sm:p-10"> */}

          {/* 🔸 Upcoming */}
          <h3 data-component-id="src/app/EventsSection.tsx:65:10" data-component-path="src/app/EventsSection.tsx" data-component-line="65" data-component-file="EventsSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-white%20text-3xl%20sm%3Atext-4xl%20font-semibold%20pb-6%20sm%3Atext-left%20text-center%22%2C%22textContent%22%3A%22Upcoming%20Events%22%7D" className="text-white text-3xl sm:text-4xl font-semibold pb-6 sm:text-left text-center">
            Upcoming Events
          </h3>

          <div data-component-id="src/app/EventsSection.tsx:69:10" data-component-path="src/app/EventsSection.tsx" data-component-line="69" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20gap-6%20mb-12%22%7D" className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12">
            {upcomingEvents.map((event, i) => (
              <Link data-component-id="src/app/EventsSection.tsx:71:14" data-component-path="src/app/EventsSection.tsx" data-component-line="71" data-component-file="EventsSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D" key={i} href={event.link} target="_blank" rel="noopener noreferrer nofollow">
                <Image data-component-id="src/app/EventsSection.tsx:72:16" data-component-path="src/app/EventsSection.tsx" data-component-line="72" data-component-file="EventsSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-full%20h-%5B280px%5D%20sm%3Ah-%5B500px%5D%20rounded-xl%22%7D"
                  src={event.src}
                  alt={event.alt}
                  width={500}
                  height={300}
                  unoptimized
                  className="w-full h-[280px] sm:h-[500px] rounded-xl"
                />
              </Link>
            ))}
          </div>

          {/* 🔸 Past */}
          <h3 data-component-id="src/app/EventsSection.tsx:85:10" data-component-path="src/app/EventsSection.tsx" data-component-line="85" data-component-file="EventsSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-white%20text-3xl%20sm%3Atext-4xl%20font-semibold%20pb-6%20sm%3Atext-left%20text-center%22%2C%22textContent%22%3A%22Past%20Events%22%7D" className="text-white text-3xl sm:text-4xl font-semibold pb-6 sm:text-left text-center">
            Past Events
          </h3>

          <div data-component-id="src/app/EventsSection.tsx:89:10" data-component-path="src/app/EventsSection.tsx" data-component-line="89" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-4%20gap-4%20sm%3Agap-6%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
            {pastEvents.map((event, i) => (
              <Link data-component-id="src/app/EventsSection.tsx:91:14" data-component-path="src/app/EventsSection.tsx" data-component-line="91" data-component-file="EventsSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D" key={i} href={event.link} target="_blank" rel="noopener noreferrer nofollow">
                <div data-component-id="src/app/EventsSection.tsx:92:16" data-component-path="src/app/EventsSection.tsx" data-component-line="92" data-component-file="EventsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-%5B%230a0a0a%5D%20rounded-lg%20p-2%20flex%20items-center%20justify-center%20hover%3Ascale-105%20transition%22%7D" className="bg-[#0a0a0a] rounded-lg p-2 flex items-center justify-center hover:scale-105 transition">
                  <Image data-component-id="src/app/EventsSection.tsx:93:18" data-component-path="src/app/EventsSection.tsx" data-component-line="93" data-component-file="EventsSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22w-full%20h-auto%20object-contain%20rounded-%5B12px%5D%22%7D"
                    src={event.src}
                    alt={event.alt}
                    width={300}
                    height={300}
                    className="w-full h-auto object-contain rounded-[12px]"
                    unoptimized
                  />
                </div>
              </Link>
            ))}
          </div>

        {/* </div> */}
      </div>
    </section>
  );
};

export default EventsSection;